<div
  inViewport
  aria-hidden="true"
  class="popsy-skeleton-component"
  *ngFor="let item of items; trackBy: trackByItem"
  [inViewportOptions]="{ threshold: [0] }"
  (inViewportAction)="onIntersection($event)"
  [class.multiline]="(items?.length || 0) > 1"
  [class.circle]="appearance === 'circle'"
  [ngStyle]="styles">
  <div class="activity"></div>
</div>
